import React, { useState } from 'react';
import theme from './DocumentUploadWizardNewVersion.module.scss';
import { useAsyncState } from '@/utils/hooks';
import { LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { searchResidentialUnitDocuments, searchProjectDocuments } from '@/services/documents';
import { Trans } from '@lingui/react/macro';
import { ResidentialUnitDocument, ProjectDocument } from '@/types';
import { useSelector } from 'react-redux';
import { IState } from '@/state/IState';
import DocumentSelectList from '@/components/DocumentSelectList';
import { SlideToggle } from '@ygtechnologies/rubus-ui';

interface DocumentUploadNewVersionProps {
    residentialUnitId?: number;
    onSelect(d: any): void;
    selectedDocumentId: string | null;
}

const DocumentUploadWizardNewVersion: React.FC<DocumentUploadNewVersionProps> = ({
    residentialUnitId,
    onSelect,
    selectedDocumentId,
}) => {
    const projectId = useSelector((state: IState) => state.seller.projectOverview.projectId);
    const [showHiddenFromBuyer, setShowHiddenFromBuyer] = useState(false);
    const [showSensitive, setShowSensitive] = useState(false);
    const [documents] = useAsyncState<ResidentialUnitDocument[] | ProjectDocument[] | null>(
        () =>
            residentialUnitId
                ? searchResidentialUnitDocuments({
                      residentialUnitIds: [residentialUnitId],
                  })
                : searchProjectDocuments({ projectId }),
        [residentialUnitId, showHiddenFromBuyer, showSensitive],
        null
    );

    if (!documents) {
        return <LoadingIndicator />;
    }
    const filteredDocuments = (documents as ResidentialUnitDocument[]).filter((d) => {
        if (!showHiddenFromBuyer && d.hideFromBuyer) {
            return false;
        }
        if (!showSensitive && d.isSensitive) {
            return false;
        }
        return true;
    });
    return (
        <>
            <div className={theme.documentContainer}>
                <DocumentSelectList
                    documents={filteredDocuments}
                    mode="document"
                    value={selectedDocumentId}
                    onSelectionChange={(value) => onSelect(filteredDocuments.find((x) => x.documentId === value))}
                />
                {/* {filteredDocuments.length === 0 && <EmptyListMessage />}
                {(filteredDocuments as any).map((d) => (
                    <DocumentListItem
                        key={d.documentId}
                        onSelect={onSelect}
                        mode="DocumentSelect"
                        isSelected={d.documentId === selectedDocumentId}
                        document={d}
                    />
                ))} */}
            </div>
            <div className={theme.bottomSection}>
                <div className="form-group">
                    <SlideToggle checked={showHiddenFromBuyer} onChange={() => setShowHiddenFromBuyer(!showHiddenFromBuyer)}>
                        <Trans>Show hidden from buyer documents</Trans>
                    </SlideToggle>
                </div>
                <div className="form-group">
                    <SlideToggle checked={showSensitive} onChange={() => setShowSensitive(!showSensitive)}>
                        <Trans>Show sensitive documents</Trans>
                    </SlideToggle>
                </div>
            </div>
        </>
    );
};

export default DocumentUploadWizardNewVersion;
